/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-14 19:49:20
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getMixinRechargeList
   * @description 充值流水
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getMxRechargeList(data) {
    return request.post(`${BASE_URL}/admin_trade/recharge_list`, data)
  },
  /**
   * getMixinWithDrawList
   * @description 交易流水
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getMxWithdrawList(data) {
    return request.post(`${BASE_URL}/admin_trade/withdraw_list`, data)
  },
}